/* ============
 * Address
 * ============
 *
 * This is the page for editing address.
 */
import { mapGetters } from 'vuex';
import Forms from './../../../../utils/forms/forms';
import countryService from './../../../../services/country';
import addressTransformer from './../../../../transformers/address';
import addressService from './../../../../services/address';
import postalService from './../../../../services/postal';

export default {
  data() {
    return {
      form: new Forms({
        streetName: {
          value: '',
          type: 'text',
        },
        secondStreetName: {
          value: '',
          type: 'text',
        },
        countryId: {
          value: 1,
          type: 'select',
        },
        postalCode: {
          value: '',
          type: 'autocomplete',
        },
        cityName: {
          value: '',
          type: 'text',
        },
      }),
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      address: 'address',
      municipalities: 'allMunicipalities',
      countries: 'allCountries',
      postals: 'allPostals',
    }),
  },

  watch: {
    /**
    * Watches state update to inject on Forms class.
    *
    * @param  {Object} postals The postals list.
    */
    postals(postals) {
      this.form.setOptions('postalCode', postals.items.map(o => (
        { name: o.postalCode }
      )));
    },

    /**
     * Watch the value of the zipcode
     */
    'form.postalCode': function (postalCode) {
      if (typeof postalCode === 'string') {
        if (postalCode.length > 3) {
          this.showCityByPostalCode(postalCode);
        }
      }

      if (typeof postalCode === 'object') {
        this.showCityByPostalCode(postalCode.name.toString());
        this.form.postalCode = postalCode.name.toString();
      }
    },

    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} countries    The countries list.
     */
    countries(countries) {
      this.form.setOptions('countryId', countries.items);
    },

    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} address    The address.
     */
    address(address) {
      this.form.assignData(address);
    },
  },

  created() {
    this.form.setOptions('countryId', this.countries.items);
    this.form.setExtraAttr('postalCode', {
      remote: postalService,
    });
    this.form.disableField('cityName');
    const requests = [];

    if (Object.keys(this.address).length === 0) {
      requests.push(addressService.show());
    }

    if (this.countries.items.length === 0) {
      requests.push(countryService.all());
    }

    this.loading = true;
    Promise.all(requests).then(() => {
      this.form.assignData(this.address);
      this.loading = false;
    });
  },

  methods: {
    /**
     * This method will be called when saving the form.
     */
    save() {
      this.form.loading = true;
      const address = addressTransformer.send(this.form.data());
      Promise.resolve(addressService.update(address))
      .then(() => {
        this.form.loading = false;
        this.form.successMessage = this.$t('static.profileAddress.addressSaveSuccess');
      })
      .catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },

    /**
     * Method to display the city
     */
    showCityByPostalCode(postalCode) {
      if (this.postals.items.length > 0) {
        const postal = this.postals.items.filter(p => (
          postalCode === p.postalCode.toString()
        ))[0];

        this.form.cityName = postal.cityName;
      }
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/profile/address/address.js